import Testimonio from './Testimonio';
import { globalperros } from "../css/backgroundcss.css";
import { fuenteglobal } from "../css/globalfont.css";
import Footer from '../components/Footer';
import Profileinterno from './Profileinterno';


const Home = () => {
    return(
        <>
          <Profileinterno/>     
                    <Testimonio/>
                   
        </>
    )
}
export default Home